<h1 class="page__title h2 mb-5">{{ 'email_list_tab' | translate }}</h1>
<wsb-atlas-button
  class="my-3"
  [disabled]="countToActiveList === 0"
  [label]="'mail_campaigns_active'"
  [sublabel]="countToActiveList"
  routerLink="/mail/campaign-setup"></wsb-atlas-button>
<wsb-atlas-grid
#grid
class="atlas-grid-simplest"
class="mt-5"
[columnDefs]="tableColumnDefs"
[options]="tableGridOptions"
[rowData]="tableRowData"
[@gridIsLoaded]="gridAnimationState"
[components]="components">
</wsb-atlas-grid>
<ng-template #modalArchive let-c="close" let-d="dismiss">
  <wsb-modal
      (primary)="modalArchivedCampaign()"
      (dismiss)="modalArchivedDismiss()"
      cancelButtonEnable="true"
      title="{{'mail_campaigns_archive_confirm_title' | translate }}"
      text="{{'mail_campaigns_archive_confirm' | translate }}">
  </wsb-modal>
</ng-template>
